
import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { InputType } from '@/enums/InputType';
import VFormBuilder from '@/components/shared/form/VFormBuilder.vue';
import StackedForm from '../../../mixins/StackedForm';
import moment from 'moment';

@Component({
  components: { VFormBuilder },
})
export default class PanicForm extends mixins(StackedForm) {
  public $refs!: {
    form: InstanceType<typeof VFormBuilder> & { form: any };
  };

  get initVals() {
    return (this.initialValues as any) || {};
  }

  get items() {
    return [
      {
        name: 'panicEndAt',
        type: InputType.DateTime,
        label: 'venue.form.panicEndAt',
        allowedDates: this.isDateTodayOrLater,
      },
      {
        name: 'panicReason',
        type: InputType.Text,
        label: 'venue.form.panicReason',
        rules: this.isPanicReasonRequired,
      },
    ];
  }

  public isDateTodayOrLater(date: string) {
    return moment(date).isSameOrAfter(moment(), 'day');
  }

  public isPanicReasonRequired(form: any) {
    if (!form.panicEndAt) {
      return '';
    }

    return this.isDateTodayOrLater(form.panicEndAt) ? 'required' : '';
  }
}
